// extracted by mini-css-extract-plugin
export default {"filterWrapper":"SideBarFilters_filterWrapper__LIxYV"};